/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Result_Heading_PluralInputs */

const en_matching_score_result_heading_plural = /** @type {(inputs: Matching_Score_Result_Heading_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result: Your matching scores`)
};

const de_matching_score_result_heading_plural = /** @type {(inputs: Matching_Score_Result_Heading_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis: Deine Matching-Scores`)
};

/**
* | output |
* | --- |
* | "Result: Your matching scores" |
*
* @param {Matching_Score_Result_Heading_PluralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_result_heading_plural = /** @type {((inputs?: Matching_Score_Result_Heading_PluralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Result_Heading_PluralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_result_heading_plural(inputs)
	return en_matching_score_result_heading_plural(inputs)
});